/**
 * Production-safe logging utility.
 * In production: no console output. In development: passes through to console.
 */
const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
    log: (..._args: unknown[]) => { if (isDevelopment) { console.log(..._args); } },
    warn: (..._args: unknown[]) => { if (isDevelopment) { console.warn(..._args); } },
    error: (..._args: unknown[]) => { if (isDevelopment) { console.error(..._args); } },
    info: (..._args: unknown[]) => { if (isDevelopment) { console.info(..._args); } },
    debug: (..._args: unknown[]) => { if (isDevelopment) { console.debug(..._args); } },
};

export default logger;
